import { AdvancedMarker, useMap } from '@vis.gl/react-google-maps'
import React, { useEffect, useRef, useState } from 'react'

import { MarkerClusterer } from '@googlemaps/markerclusterer'
import { PointGoogle, Property, RealEstateData, StatePropertiesSlice } from 'types'
import { addMarker, checkMarker, scrollOnGrid, thisMarkerIsDevelopment } from '@helpers/helper.map'
import { getPrices, searchUnitiesInResults } from '@helpers/helper.properties'
import { getPriceForMarker } from '@helpers/helper.rendering'
import { changeSelectedAction, updateMapAction } from '@slices/propertiesSlice'
import { useDispatch, useSelector } from 'react-redux'
import useQueryProperties from '@hooks/useQueryProperties'
import { Modal } from 'bootstrap'

// type Point = { lat: number; lng: number }
type Point = PointGoogle
type MarkersProps = { global_data: RealEstateData; points: Point[]; map?: google.maps.Map | null }

// const Markers = ({ points, map }: MarkersProps) => {
const Markers = ({ points, global_data }: MarkersProps) => {
  const map = useMap()
  const dispatch = useDispatch()
  const clusterer = useRef<MarkerClusterer | null>(null)

  const API_KEY = global_data.pageConfig.keys.tokko

  const element = document.getElementById('exampleModal') as HTMLElement
  const myModal = new Modal(element)

  const clusterStyles = [
    {
      url: 'https://developers.google.com/maps/documentation/javascript/examples/clusterer/m3.png',
      textColor: 'white',
      textSize: 14,
      width: 50,
      height: 50,
    },
  ]

  const clusterOptions = {
    styles: clusterStyles,
    gridSize: 50,
    maxZoom: 15,
    minimumClusterSize: 3,
  }

  const {
    filters,
    offset,
    orders,
    coordinates,
    polygonCoordinates,
    selected,
    viewId,
  }: StatePropertiesSlice = useSelector(
    (state: { properties: StatePropertiesSlice }) => state.properties,
  )
  const { properties, isLoading } = useQueryProperties({
    filters,
    coordinates,
    polygonCoordinates,
    orders,
    offset,
    tokkoKey: API_KEY,
  })

  function getCSSVariableValue(variableName: string) {
    // Obtiene el valor de la variable CSS
    var value = getComputedStyle(document.documentElement).getPropertyValue(variableName)

    // Devuelve el valor sin espacios al inicio o al final
    return value.trim()
  }

  // Ejemplo de uso:
  var primaryColorValue = getCSSVariableValue('--primaryColor')
  var secondaryColorValue = getCSSVariableValue('--secondaryColor')

  const renderer = {
    render: ({ count, position }: any) => {
      const color = secondaryColorValue
      // create svg url with fill color
      const svg = window.btoa(`
        <svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
          <circle fill="#1f1f1f" cx="120" cy="120" opacity=".3" r="90" />    
          <circle fill="#fff" cx="120" cy="120" opacity="1" r="68" />    
          <circle cx="120" cy="120" opacity="1" r="65" />    
        </svg>`)
      // create marker using svg icon
      return new google.maps.Marker({
        position,
        icon: {
          url: `data:image/svg+xml;base64,${svg}`,
          scaledSize: new google.maps.Size(75, 75),
        },
        label: {
          text: String(count),
          color: 'rgba(255,255,255,0.9)',
          fontSize: '12px',
        },
        // adjust zIndex to be above other markers
        zIndex: 99999,
      })
    },
    // new google.maps.Marker({
    //   label: { text: String(count), color: 'white', fontSize: '10px' },
    //   position,
    //   // adjust zIndex to be above other markers
    //   zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
    // }),
  }

  useEffect(() => {
    if (!map) return
    if (!clusterer.current) {
      clusterer.current = new MarkerClusterer({
        map,
        renderer,
      })
    }
  }, [map])

  const markersRef = useRef<{ [key: string]: any }>({})

  const [_forceRender, setForceRender] = useState('')

  const [firstRefresh, setTimer] = useState(false)

  return (
    <>
      {points.map((point, index) => {
        const key = JSON.stringify(point.geometry.coordinates) + index
        return (
          <AdvancedMarker
            position={point.geometry.coordinates}
            key={key}
            ref={(marker) => {
              if (!index) markersRef.current = {}
              if (!marker) return
              markersRef.current = { ...markersRef.current, [key]: marker }
              if (index !== points.length - 1) return
              clusterer.current?.clearMarkers()
              clusterer.current?.addMarkers(Object.values(markersRef.current))
              setForceRender(key)
            }}
            onClick={() => {
              viewId === 1 || point.property.development?.id ? myModal.show() : null
              dispatch(changeSelectedAction(point.properties.propId))
              scrollOnGrid(point.properties.propId.toString())
              addMarker(point.properties.propId)
            }}
          >
            <div
              // data-bs-toggle={'modal'}
              // data-bs-toggle={viewId === 1 || point.property.development?.id ? 'modal' : ''}
              // data-bs-target="#exampleModal"
              className={`bubble-marker ${
                selected && selected !== point.properties.propId
                  ? 'opacity'
                  : selected === point.properties.propId
                  ? 'selected-marker'
                  : ''
              } ${filters.operation}${
                checkMarker(
                  point.property.development?.id.toString()
                    ? point.property.development?.id.toString()
                    : point.properties.propId.toString(),
                )
                  ? ' active '
                  : ''
              } ${thisMarkerIsDevelopment(point, searchUnitiesInResults) ? 'is_development' : ''}`}
            >
              <i
                className={
                  (thisMarkerIsDevelopment(point, searchUnitiesInResults)
                    ? ' icon-marker-emprendimiento '
                    : ' icon-marker ') +
                  (checkMarker(
                    point.property.development?.id.toString()
                      ? point.property.development?.id.toString()
                      : point.properties.propId.toString(),
                  )
                    ? ' active '
                    : '')
                }
              ></i>
              <h5>
                {thisMarkerIsDevelopment(point, searchUnitiesInResults)
                  ? isLoading
                    ? '...'
                    : properties?.objects.filter(
                        (prop: Property) =>
                          prop.development?.id === point.property?.development?.id,
                      ).length || '?'
                  : getPriceForMarker(getPrices(point.property, filters.operation))}
              </h5>
            </div>
          </AdvancedMarker>
        )
      })}
    </>
  )
}

export default Markers
